let menuBtn = document.querySelector(".Burger")
let menu = document.querySelector(".menu")
let closeItem = document.querySelector(".closeItem")

let bad_menuBtn = document.querySelector(".bad_Burger")
let bad_menu = document.querySelector(".bad_menu")
let bad_closeItem = document.querySelector(".bad_closeItem")

menuBtn.addEventListener('click', function () {

    menu.classList.toggle("activ")

})
closeItem.addEventListener('click', function () {
    menu.classList.remove("activ")
})
bad_menuBtn.addEventListener('click', function () {

    bad_menu.classList.toggle("activ")

})
bad_closeItem.addEventListener('click', function () {
    bad_menu.classList.remove("activ")
})

let CheckQuestion = document.querySelectorAll(".clickbox")
let spanCheking = document.querySelectorAll(".yellowbox")
const CheckQuestionArr = Array.from(CheckQuestion)
const spanArr = Array.from(spanCheking)
let AnswerBtn = document.querySelector(".forward_btn")
let kol = 0;

for (let i = 0; i < CheckQuestionArr.length; i++) {

    CheckQuestionArr[i].addEventListener('click', function () {

        if (spanArr[i].classList.contains("active")) {
            spanArr[i].classList.remove("active")
            kol -= 1

        } else {
            spanArr[i].classList.add("active")
            kol += 1
        }
        if (kol !== 0) {
            AnswerBtn.classList.remove("answer_btn")

            AnswerBtn.removeAttribute("disabled")

        } else {
            AnswerBtn.setAttribute("disabled", "true")
            AnswerBtn.classList.add("answer_btn")
        }


    })

}

for (let i = 0; i < spanArr.length; i++) {
    if (spanArr[i].classList.contains("active")) {
        kol += 1
    } else {}
}
if (kol == 0) {

}


let goodPage = document.getElementById('GoodContainer')
let badPage = document.getElementById('BadContainer')

let question1Btn = document.getElementById('question1')
let question2Btn = document.getElementById('question2')
let question3Btn = document.getElementById('question3')
let question4Btn = document.getElementById('question4')
let question5Btn = document.getElementById('question5')
let chek = 0;

function CheckAnswer() {
    let counter = 0;
    let trueCount = 0;
    let falseCount = 0;


    spanArr.forEach((elem) => {
        if (elem.getAttribute("data") === "true") {
            counter++;
            if (elem.classList.contains("active")) {
                trueCount++;
            }
        }
        if (elem.getAttribute("data") === "false" && elem.classList.contains("active")) {
            falseCount++;
        }
        // if (elem.getAttribute("data") === "true" && ) {
        // }

    })

    if (trueCount === counter && falseCount === 0) {
        goodPage.classList.add('active')

        chek += 1

    } else {
        badPage.classList.add('active')
        if (badPage.classList.contains("active")) {

            document.querySelector(".body-container").classList.add("disable")
        } else {
            document.querySelector(".body-container").classList.remove("disable")
        }
    }


}
// Подвязываем события к кнопкам вопросов


question1Btn && question1Btn.addEventListener('click', function () {


    CheckAnswer();

    SearchElem(1)


    if (document.getElementById('GoodContainer').classList.contains("active") && (document.documentElement.clientWidth < 768)) {

        document.querySelector(".body-container").style.height = 675 + "px";
    }


    if (document.getElementById('BadContainer').classList.contains("active")) {
        console.log("hel")
        document.querySelector(".bad-container").style.height = 760 + "px";
    }


    if (document.getElementById('badContent1').classList.contains("activation") && (window.clientWidth < 768)) {
        console.log("helwqqwq")
        document.querySelector(".bad-container").style.height = 760 + "px";
    }


    var answers = document.getElementsByClassName('clickbox')
    var answers_arr = [];
    for (var i=0; i<answers.length; i++){
        if (answers[i].getElementsByClassName('yellowbox')[0].classList.contains('active')) {
            answers_arr.push(answers[i].getElementsByTagName('p')[0].innerHTML)
        }
    }

    let postObj = {
        answer: answers_arr.join(', ')
    }
    let post = JSON.stringify(postObj)
    const url = "add_question1.php"
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
    xhr.send(post);
    xhr.onload = function () {
        if(xhr.status === 201) {
            console.log("Post successfully created!")
        }
    }

})


question2Btn && question2Btn.addEventListener('click', function () {


    CheckAnswer();
    SearchElem(2)
    if (document.getElementById('GoodContainer').classList.contains("active") && (document.documentElement.clientWidth < 768)) {
        console.log("hel")
        document.querySelector(".body-container").style.height = 675 + "px";
    }
    if (document.getElementById('BadContainer').classList.contains("active")) {
        console.log("hel")
        document.querySelector(".bad-container").style.height = 760 + "px";
    }
    if (document.getElementById('badContent2').classList.contains("activation") && (document.documentElement.clientWidth < 768)) {
        console.log("hel")
        document.querySelector(".bad-container").style.height = 760 + "px";
    }

    var answers = document.getElementsByClassName('clickbox')
    var answers_arr = [];
    for (var i=0; i<answers.length; i++){
        if (answers[i].getElementsByClassName('yellowbox')[0].classList.contains('active')) {
            answers_arr.push(answers[i].getElementsByTagName('p')[0].innerHTML)
        }
    }
    let postObj = {
        answer: answers_arr.join(', ')
    }

    let post = JSON.stringify(postObj)
    const url = "add_question2.php"
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
    xhr.send(post);
    xhr.onload = function () {
        if(xhr.status === 201) {
            console.log("Post successfully created!")
        }
    }

})


question3Btn && question3Btn.addEventListener('click', function () {


    CheckAnswer();
    SearchElem(3)
  
    if (document.getElementById('BadContainer').classList.contains("active")) {
        console.log("hel")
        document.querySelector(".bad-container").style.height = 760 + "px";
    }
    if (document.getElementById('badContent3').classList.contains("activation") && (document.documentElement.clientWidth < 768)) {
        console.log("hel")
        document.querySelector(".bad-container").style.height = 830 + "px";
    }
    if (document.getElementById('GoodContainer').classList.contains("active") && (document.documentElement.clientWidth < 768)) {
        console.log("hel")
        document.querySelector(".body-container").style.height = 675 + "px";
    }

    var answers = document.getElementsByClassName('clickbox')
    var answers_arr = [];
    for (var i=0; i<answers.length; i++){
        if (answers[i].getElementsByClassName('yellowbox')[0].classList.contains('active')) {
            answers_arr.push(answers[i].getElementsByTagName('p')[0].innerHTML)
        }
    }

    let postObj = {
        answer: answers_arr.join(', ')
    }
    let post = JSON.stringify(postObj)
    const url = "add_question3.php"
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
    xhr.send(post);
    xhr.onload = function () {
        if(xhr.status === 201) {
            console.log("Post successfully created!")
        }
    }


})
question4Btn && question4Btn.addEventListener('click', function () {


    CheckAnswer();
    SearchElem(4)
    if (document.getElementById('GoodContainer').classList.contains("active") && (document.documentElement.clientWidth < 768)) {

        document.querySelector(".body-container").style.height = 675 + "px";
    }
    if (document.getElementById('BadContainer').classList.contains("active")) {
        console.log("hel")
        document.querySelector(".bad-container").style.height = 760 + "px";
    }
    if (document.getElementById('badContent4').classList.contains("activation") && (document.documentElement.clientWidth < 768)) {

        document.querySelector(".bad-container").style.height = 700 + "px";
    }

    var answers = document.getElementsByClassName('clickbox')
    var answers_arr = [];
    for (var i=0; i<answers.length; i++){
        if (answers[i].getElementsByClassName('yellowbox')[0].classList.contains('active')) {
            answers_arr.push(answers[i].getElementsByTagName('p')[0].innerHTML)
        }
    }
    let postObj = {
        answer: answers_arr.join(', ')
    }

    let post = JSON.stringify(postObj)
    const url = "add_question4.php"
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
    xhr.send(post);
    xhr.onload = function () {
        if(xhr.status === 201) {
            console.log("Post successfully created!")
        }
    }

})
question5Btn && question5Btn.addEventListener('click', function () {


    CheckAnswer();
    SearchElem(5)
    if (document.getElementById('GoodContainer').classList.contains("active") && (document.documentElement.clientWidth < 768)) {
        console.log("hel")
        document.querySelector(".body-container").style.height = 675 + "px";


    }
    if (document.getElementById('BadContainer').classList.contains("active")) {
        console.log("hel")
        document.querySelector(".bad-container").style.height = 760 + "px";
    }
    if (document.getElementById('badContent5').classList.contains("activation") && (document.documentElement.clientWidth < 768)) {
        console.log("hel")
        document.querySelector(".bad-container").style.height = 790 + "px";
    }

    var answers = document.getElementsByClassName('clickbox')
    var answers_arr = [];
    for (var i=0; i<answers.length; i++){
        if (answers[i].getElementsByClassName('yellowbox')[0].classList.contains('active')) {
            answers_arr.push(answers[i].getElementsByTagName('p')[0].innerHTML)
        }
    }
    let postObj = {
        answer: answers_arr.join(', ')
    }

    let post = JSON.stringify(postObj)
    const url = "add_question5.php"
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
    xhr.send(post);
    xhr.onload = function () {
        if(xhr.status === 201) {
            console.log("Post successfully created!")
        }
    }


})



function SearchElem(page) {
    // Берем тайтл
    let GoodTittleArray = Array.from(document.querySelectorAll(".good-tittle"))
    let BadTittleArray = Array.from(document.querySelectorAll(".bad-tittle"))
    // Берем Часть с текстом и картинками
    let GoodContentArray = Array.from(document.querySelectorAll(".good-container-content"))
    let BadContentArray = Array.from(document.querySelectorAll(".bad-container-content"))
    // Берем кнопки каждой страницы
    let BtnArray = Array.from(document.querySelectorAll(".next_questBtn"))

    let good = false;


    function BadOrGood() {

        if (chek === 1) good = true
    }

    BadOrGood(good);

    function Visibl(Array) {
        Array.forEach((elem) => {
            if (Number(elem.id.slice(-1)) === page) {
                elem.classList.toggle("activation")
            }


        })


    }

    if (good) {
        Visibl(GoodTittleArray)
        Visibl(GoodContentArray)
        Visibl(BtnArray)
    } else {
        Visibl(BadTittleArray)
        Visibl(BadContentArray)
        Visibl(BtnArray)
    }





}

document.addEventListener('DOMContentLoaded', function () {

    var animatedObjectAll = document.querySelectorAll('.animated');
    animatedObjectAll.forEach(function (elem) {
        elem.classList.add('show');

    })

 
});

if (document.documentElement.clientWidth <= 700) {
    document.querySelector(".bg").style.backgroundImage = "url('./img/bg_mob.jpg')";
}
if (document.getElementById('firstBgMob')) {
    if (document.documentElement.clientWidth <= 700){
    document.querySelector(".bg").style.backgroundImage = "url('./img/firstBgMob.jpg')";
}}
if (document.getElementById('QuestionMobBg')) {
    if (document.documentElement.clientWidth <= 700){
    document.querySelector(".bg").style.backgroundImage = "url('./img/QuestionMobBg.jpg')";
}}

let fisrtBut = document.getElementById("firstBut");
console.log(window.location.hash)
if( window.location.hash== "#q1"){
    firstBut.setAttribute("href","QuestionPage1.html")
}
else if(window.location.hash== "#q2"){
    firstBut.setAttribute("href","QuestionPage2.html")
}
else if(window.location.hash== "#q3"){
    firstBut.setAttribute("href","QuestionPage3.html")
}
else if(window.location.hash== "#q4"){
    firstBut.setAttribute("href","QuestionPage4.html")
}
else if(window.location.hash== "#q5"){
    firstBut.setAttribute("href","QuestionPage5.html")
}